import { render } from "./SidebarItemV2.vue?vue&type=template&id=6d7dcd3e"
import script from "./SidebarItemV2.vue?vue&type=script&lang=js"
export * from "./SidebarItemV2.vue?vue&type=script&lang=js"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__